export default __webpack_public_path__ + "static/media/preview-end.c9d0f65f.png";